/*
 * Main file
 */
import 'pretendard/dist/web/variable/pretendardvariable.css';
import Vue from 'vue';
import router from '@/router';
import App from '@/App.vue';
import store from '@/store';

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';

import BaseLayoutModifier from '@/components/BaseLayoutModifier';
import BaseBlock from '@/components/BaseBlock';
import UrgentAlert from '@/views/Modal/UrgentAlert';
import Webtoon from '@/views/Modal/Webtoon';
import Withdraw from '@/views/Modal/Withdraw';
import GuideModal from '@/views/Modal/GuideModal';
import EventModal from '@/views/Modal/EventModal';
import NoPhone from '@/views/Modal/NoPhone';
import AttendanceAlert from '@/views/Modal/Attendance';
import LandingEventModal from '@/views/Modal/LandingModal';
import SetLanguage from '@/views/Components/SetLanguage';

import VueGtag from 'vue-gtag';
import { api } from '@/helpers/axios';
import i18n from '@/plugins/i18n';
import { DateTime } from 'luxon';
import VueCookies from 'vue-cookies';
import Flicking from '@egjs/vue-flicking';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import InfiniteLoading from 'vue-infinite-loading';
import VueBottomSheet from '@webzlodimir/vue-bottom-sheet';
import PortalVue from 'portal-vue';

import niceId from '@/plugins/niceId.js';
import lottoCalendar from '@/plugins/lottoCalendar.js';
import telOptions from '@/helpers/vueTelInputOptions.js';

const form_link = {
  ko: 'https://forms.gle/L27qfKsrYryHZFJb9',
  en: 'https://docs.google.com/forms/d/e/1FAIpQLSf-JaQIJU9pyzDn2reymYIv7Wg_hY6eotIMQGlbMI8XDUSvrg/viewform',
};
const notice_link = {
  ko: 'https://sour-change-1b9.notion.site/8848976949294067a430bed78d044417',
  en: 'https://sour-change-1b9.notion.site/d23b40413839472e9a75f850ce2902e9',
};
const webtoon_link = 'https://sour-change-1b9.notion.site/1-5104ab4735764a7e8ee1a53861300257';
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

Vue.prototype.$axios = api;
Vue.prototype.$DateTime = DateTime;
Vue.prototype.$inquiry = (lang) => {
  return form_link[lang];
};
Vue.prototype.$notice = (lang) => {
  return notice_link[lang];
};
Vue.prototype.$webtoon = webtoon_link;
Vue.prototype.$ver = `ver=${process.env.VUE_APP_VERSION}`;
Vue.prototype.$s3 = process.env.VUE_APP_S3_URL;
/** setTimeLocalization */
Vue.prototype.$everyMidnight = (lang, foramat) => {
  const now = DateTime.now();
  const { zoneName } = now;
  const seoulNow = now.setZone('Asia/Seoul');
  const seoulNowISO = seoulNow.toISO();
  const [date] = seoulNowISO.split('T');
  const midnight = DateTime.fromISO(date, { zone: 'Asia/Seoul' }).setZone(zoneName).setLocale(lang).toFormat(foramat);

  return midnight;
};
Vue.prototype.$everydayTime = (lang, time, foramat) => {
  const now = DateTime.now();
  const { zoneName } = now;
  const seoulNow = now.setZone('Asia/Seoul');
  const seoulNowISO = seoulNow.toISO();
  const [date] = seoulNowISO.split('T');
  const everydayTime = DateTime.fromISO(`${date}T${time}`, { zone: 'Asia/Seoul' })
    .setZone(zoneName)
    .setLocale(lang)
    .toFormat(foramat);

  return everydayTime;
};
Vue.prototype.$tl = (time, locale) =>
  DateTime.fromISO(time, { zone: 'Asia/seoul' })
    .setZone(timezone)
    .setLocale(locale ? locale : 'en');
Vue.prototype.$tfDate = (time) =>
  time
    .toLocaleString({
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    .split('. ')
    .map((v) => v.replace('.', ''))
    .join('.');
Vue.prototype.$tfDateShort = (time) =>
  time
    .toLocaleString({
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    })
    .split('. ')
    .map((v) => v.replace('.', ''))
    .join('.');

const transKo = (date) => {
  const [y, m] = date.split('.');
  if (!m) return date;
  return `${y}.${m.padStart(2, 0)}.`;
};
Vue.prototype.$tfDateMonth = (time) =>
  transKo(
    time
      .toLocaleString({
        year: 'numeric',
        month: '2-digit',
      })
      .replaceAll('. ', '.')
  );
Vue.prototype.$tfMonthDay = (time) =>
  time
    .toLocaleString({
      month: '2-digit',
      day: '2-digit',
    })
    .replaceAll('. ', '.');
Vue.prototype.$tfDateFull = (time) =>
  `${time
    .toLocaleString({
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    .replaceAll('. ', '.')} ${time.toFormat('HH:mm:ss')}`;
Vue.prototype.$tfTimeHM = (time) => `${time.toFormat('HH:mm')}`;
Vue.prototype.$timezoneName = (time) => `${time.toFormat('ZZZZ')}`;
Vue.prototype.$colorSelector = (num) => {
  if (num === 0) {
    return 'default';
  } else if (num < 11) {
    return 'red';
  } else if (num < 21) {
    return 'blue';
  } else if (num < 31) {
    return 'yellow';
  } else if (num < 41) {
    return 'green';
  } else {
    return 'purple';
  }
};
Vue.prototype.$commaNum = (value) => (value ? String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0);

Vue.prototype.$scrollTo = scrollTo;

// Register global plugins
Vue.use(Flicking);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueCookies, { expires: '7d' });
Vue.use(niceId);
Vue.use(lottoCalendar);
Vue.use(VueGtag, { config: { id: process.env.VUE_APP_GTAG } }, router);
Vue.use(VueTelInput, telOptions);
Vue.use(InfiniteLoading);
Vue.use(VueBottomSheet);
Vue.use(PortalVue);

Vue.component(BaseLayoutModifier.name, BaseLayoutModifier);
Vue.component(BaseBlock.name, BaseBlock);
Vue.component(UrgentAlert.name, UrgentAlert);
Vue.component(Webtoon.name, Webtoon);
Vue.component(Withdraw.name, Withdraw);
Vue.component(GuideModal.name, GuideModal);
Vue.component(EventModal.name, EventModal);
Vue.component(NoPhone.name, NoPhone);
Vue.component(AttendanceAlert.name, AttendanceAlert);
Vue.component(LandingEventModal.name, LandingEventModal);

Vue.component(SetLanguage.name, SetLanguage);

Vue.directive('click-outside', {
  bind: (el, binding, vnode) => {
    el.clickOutsideEvent = (event) => {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: (el) => {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

// Disable tip shown in dev console when in development mode
Vue.config.productionTip = false;

// Craft new application
new Vue({
  i18n,
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
